
export default {
    name: 'DepositInProgress',
    props: {
        referenceId: {
            type: String,
            default: null,
        },
        text: {
            type: String,
            default: null,
        },
    },
}
